import needsSignature from './needsSignature';
import isPopupAssignedToSigner from './isPopupAssignedToSigner';

export default signerAddress => popup =>
  isPopupAssignedToSigner(signerAddress)(popup) && needsSignature(popup);



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/needsToBeSignedBy.jsx